import actions from "./actions";
import getters from "./getters";
import mutations from "./mutations";
import state from "./state";

export const TRADE_ESTIMATE_STORE = "tradeEstimate";

export default {
  namespaced: true,

  state,

  actions,

  getters,

  mutations,
};
